module.exports = __webpack_public_path__ + "img/slides.5c0c5bba.svg";